import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import LeftNavList from '../../components/common/LeftNav/LeftNavList';

function LeftNav(props) {
  const [activeParentNavVal, setActiveParentNavVal] = useState({});

  const toggleParentNav = navName => {
    const activeParent = { ...activeParentNavVal };
    if (activeParent[navName]) {
      activeParent[navName] = false;
    } else {
      activeParent[navName] = true;
    }
    setActiveParentNavVal(activeParent);
  };

  useEffect(() => {
    const { navItems } = props;
    const activeParentNav = { ...activeParentNav };
    activeParentNav[navItems[0].name] = true;
    setActiveParentNavVal(activeParentNav);
  }, []);

  useEffect(() => {}, [props.navItems, activeParentNavVal]);

  return (
    <LeftNavList
      data-test="leftNavTest"
      navItems={props.navItems}
      setSupportNav={props.setSupportNav}
      activeParentNav={activeParentNavVal}
      toggleParentNav={toggleParentNav}
    />
  );
}

LeftNav.propTypes = {
  navItems: PropTypes.instanceOf(Array),
  setSupportNav: PropTypes.func,
};

export default memo(LeftNav);
